export function getAppStage() {
  return import.meta.env.MODE as 'development' | 'staging' | 'production';
}
